import { OngoingAssessmentStatus } from '@/gen/inventory/v1/ongoing_assessment_pb'

import { ongoingAssessmentStatusLabel } from '@/const/label'

import { Badge, BadgeProps } from '@/components/lemmala-design-system/badge/badge'

const ongoingAssessmentStatusVariant: Record<OngoingAssessmentStatus, BadgeProps['variant']> = {
  [OngoingAssessmentStatus.UNSPECIFIED]: 'secondary',
  [OngoingAssessmentStatus.READY_TO_START]: 'neutral',
  [OngoingAssessmentStatus.IN_PROGRESS]: 'promotion',
  [OngoingAssessmentStatus.AWAITING_APPROVAL]: 'warning',
  [OngoingAssessmentStatus.COMPLETED]: 'success',
}

type OngoingAssessmentStatusBadgeProps = {
  status: OngoingAssessmentStatus
}

export const OngoingAssessmentStatusBadge = ({ status }: OngoingAssessmentStatusBadgeProps) => {
  return (
    <Badge
      variant={ongoingAssessmentStatusVariant[status]}
      badgeStyle='subtle'
      textCase='title'
      className='w-fit text-nowrap'
    >
      {ongoingAssessmentStatusLabel[status]}
    </Badge>
  )
}
